import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Employee } from 'service/Models';
import ServerGateway from 'service/ServerGateway';
import { NavLink } from 'react-router-dom';

export const Notifications = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [numberOfDays, setNumberOfDays] = useState<number>(15);
    const [fromDate, setFromDate] = useState<string>(moment().format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState<string>();
    const [upcomingBirthdays, setUpcomingBirthdays] = useState<any[]>([]);
    const [upcomingWorkAnniversaries, setupcomingWorkAnniversaries] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setToDate(moment().add(numberOfDays, 'days').format("YYYY-MM-DD"));
    }, [numberOfDays]);

    useEffect(() => {
        if (toDate) {
            loadUpcomingBirthDays();
        }
    }, [fromDate, toDate]);

    const loadUpcomingBirthDays = () => {
        setIsLoading(true);
        ServerGateway.getUpcomingBirthdays(fromDate, toDate)
            .then((data) => {
                const employeesWithBirthdays = data.map(emp => ({
                    ...emp,
                    birthdayInfo: getBirthdayMessage(emp.dob, emp.name)
                }));
                setUpcomingBirthdays(employeesWithBirthdays);
                loadUpcomingWorkAnniversaries();
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadUpcomingWorkAnniversaries = () => {
        setIsLoading(true);
        ServerGateway.getUpcomingWorkAnniversaries(fromDate, toDate)
            .then((data) => {
                const employeesWithAnniversary = data.map(emp => ({
                    ...emp,
                    anniversaryInfo: getWorkAnniversaryMessage(emp.joiningDate)
                }));

                setupcomingWorkAnniversaries(employeesWithAnniversary);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const getBirthdayMessage = (dateOfBirth, name = "Turning") => {
        // Convert DOB to Date object if it's a string
        const dob = new Date(dateOfBirth);
        let today = new Date();
        today = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        // Check if the date is valid
        if (isNaN(dob.getTime())) {
            throw new Error('Invalid date format');
        }

        // Get current year and calculate this year's employee
        const currentYear = today.getFullYear();
        const thisYearBirthday = new Date(currentYear, dob.getMonth(), dob.getDate());

        // If employee has already passed this year, use next year's employee
        let upcomingBirthday;
        let ageOnBirthday;

        if (thisYearBirthday < today) {
            // Birthday already passed, use next year
            upcomingBirthday = new Date(currentYear + 1, dob.getMonth(), dob.getDate());
            ageOnBirthday = (currentYear + 1) - dob.getFullYear();
        } else {
            // Birthday is upcoming this year
            upcomingBirthday = thisYearBirthday;
            ageOnBirthday = currentYear - dob.getFullYear();
        }

        // Calculate days until employee
        const timeDiff = upcomingBirthday.getTime() - today.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        // Format the upcoming employee
        const options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        let formattedDate = upcomingBirthday.toLocaleDateString('en-US', options);

        // Add relative time suffix if appropriate
        if (daysDiff === 0) {
            formattedDate += ' (today)';
        } else if (daysDiff === 1) {
            formattedDate += ' (tomorrow)';
        } else if (daysDiff <= 7) {
            const dayName = upcomingBirthday.toLocaleDateString('en-US', { weekday: 'long' });
            formattedDate += ` (this ${dayName})`;
        } else if (daysDiff <= 14) {
            const dayName = upcomingBirthday.toLocaleDateString('en-US', { weekday: 'long' });
            formattedDate += ` (next ${dayName})`;
        }

        return {
            message: `Turning ${ageOnBirthday} years on ${formattedDate}`,
            daysDiff,
            age: ageOnBirthday,
            date: upcomingBirthday
        };
    }

    const getWorkAnniversaryMessage = (joiningDate, name = "Completing") => {
        // Convert DOB to Date object if it's a string
        const dob = new Date(joiningDate);
        let today = new Date();
        today = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        // Check if the date is valid
        if (isNaN(dob.getTime())) {
            throw new Error('Invalid date format');
        }

        // Get current year and calculate this year's employee
        const currentYear = today.getFullYear();
        const thisYearBirthday = new Date(currentYear, dob.getMonth(), dob.getDate());

        // If employee has already passed this year, use next year's employee
        let upcomingBirthday;
        let ageOnBirthday;

        if (thisYearBirthday < today) {
            // Birthday already passed, use next year
            upcomingBirthday = new Date(currentYear + 1, dob.getMonth(), dob.getDate());
            ageOnBirthday = (currentYear + 1) - dob.getFullYear();
        } else {
            // Birthday is upcoming this year
            upcomingBirthday = thisYearBirthday;
            ageOnBirthday = currentYear - dob.getFullYear();
        }

        // Calculate days until employee
        const timeDiff = upcomingBirthday.getTime() - today.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        // Format the upcoming employee
        const options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        let formattedDate = upcomingBirthday.toLocaleDateString('en-US', options);

        // Add relative time suffix if appropriate
        if (daysDiff === 0) {
            formattedDate += ' (today)';
        } else if (daysDiff === 1) {
            formattedDate += ' (tomorrow)';
        } else if (daysDiff <= 7) {
            const dayName = upcomingBirthday.toLocaleDateString('en-US', { weekday: 'long' });
            formattedDate += ` (this ${dayName})`;
        } else if (daysDiff <= 14) {
            const dayName = upcomingBirthday.toLocaleDateString('en-US', { weekday: 'long' });
            formattedDate += ` (next ${dayName})`;
        }

        return {
            message: `${name} ${ageOnBirthday} years on ${formattedDate}`,
            daysDiff,
            age: ageOnBirthday,
            date: upcomingBirthday
        };
    }

    const getBadgeClass = (daysDiff) => {
        if (daysDiff === 0) return 'bg-danger';
        if (daysDiff <= 3) return 'bg-warning';
        if (daysDiff <= 7) return 'bg-info';
        return 'bg-secondary';
    };

    const getBadgeText = (daysDiff) => {
        if (daysDiff === 0) return 'Today!';
        if (daysDiff === 1) return 'Tomorrow';
        if (daysDiff <= 7) return `${daysDiff} days`;
        if (daysDiff <= 30) return `${daysDiff} days`;
        return `${Math.floor(daysDiff / 30)} months`;
    };


    return (
        <div className="page-employees">
            <div className='container'>
                {isLoading &&
                    <Loader />
                }
                {!isLoading &&
                    <>
                        <div className='row mb-3'>
                            <div className="col-12">
                                <div className="card shadow-sm">
                                    <div className="card-header bg-success text-white">
                                        <h4 className="card-title mb-0">
                                            <i className="bi bi-calendar-event me-2"></i>
                                            Upcoming Employee Birthdays
                                        </h4>
                                        {/*<small className="text-light">Celebrate with your colleagues!</small>*/}
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="list-group list-group-flush">
                                            {upcomingBirthdays?.map((employee) => (
                                                <div key={employee.id} className="list-group-item list-group-item-action">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div>
                                                                    <h6 className="mb-1 fw-bold">{employee.name}</h6>
                                                                    <p className="mb-1 text-muted small">{employee.designationName} - {employee.groupName}</p>
                                                                    <small className="text-muted">
                                                                        {employee.birthdayInfo.message}
                                                                    </small>
                                                                </div>
                                                                <div className="text-end">
                                                                    <span className={`badge rounded-pill ${getBadgeClass(employee.birthdayInfo.daysDiff)} mb-1`}>
                                                                        {getBadgeText(employee.birthdayInfo.daysDiff)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {employee.birthdayInfo.daysDiff === 0 && (
                                                        <div className="mt-2">
                                                            <div className="alert alert-success py-2 mb-0">
                                                                <i className="bi bi-gift me-1"></i>
                                                                <small><strong>It's {employee.name}'s birthday today! 🎉</strong></small>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                            {upcomingBirthdays.length === 0 &&
                                                <div className="list-group-item">
                                                    <div className="alert alert-info">No upcoming birthdays in next {numberOfDays} days</div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-12">
                                <div className="card shadow-sm">
                                    <div className="card-header bg-success text-white">
                                        <h4 className="card-title mb-0">
                                            <i className="bi bi-calendar-event me-2"></i>
                                            Upcoming Work Anniversaries
                                        </h4>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="list-group list-group-flush">
                                            {upcomingWorkAnniversaries?.map((employee) => (
                                                <div key={employee.id} className="list-group-item list-group-item-action">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div>
                                                                    <h6 className="mb-1 fw-bold">{employee.name}</h6>
                                                                    <p className="mb-1 text-muted small">{employee.designationName} - {employee.groupName}</p>
                                                                    <small className="text-muted">
                                                                        {employee.anniversaryInfo.message}
                                                                    </small>
                                                                </div>
                                                                <div className="text-end">
                                                                    <span className={`badge rounded-pill ${getBadgeClass(employee.anniversaryInfo.daysDiff)} mb-1`}>
                                                                        {getBadgeText(employee.anniversaryInfo.daysDiff)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {employee.anniversaryInfo.daysDiff === 0 && (
                                                        <div className="mt-2">
                                                            <div className="alert alert-success py-2 mb-0">
                                                                <i className="bi bi-gift me-1"></i>
                                                                <small><strong>It's {employee.name}'s work anniversary today! 🎉</strong></small>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                            {upcomingWorkAnniversaries.length === 0 &&
                                                <div className="list-group-item">
                                                    <div className="alert alert-info">No upcoming work anniversary in next {numberOfDays} days</div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    );
}